import { Box, Container, Grid, Typography } from "@mui/material"
import { useApiGet, useApiPut } from "auth/useApi2"
import { GlobalLoaderContext } from "components/GlobalLoadingProvider"
import { PageTabs } from "components/navigation/PageTabs/PageTabs"
import { apiEndpoints } from "generated/apiEndpoints"
import { allRoutes } from "generated/routes"
import { useContext, useEffect } from "react"
import { DeviceForm } from "../../components/DeviceForm"
import { useTranslation } from "react-i18next"

const DeviceRegisterEdit = ({ match }) => {
  const { t } = useTranslation()
  const [deviceResult, getDevice] = useApiGet()
  const [editDeviceResult, editDevice] = useApiPut()
  const [companyResult, getCompany] = useApiGet()
  const [externalDeviceResult, getExternalDevice] = useApiGet()
  const loadingContext = useContext(GlobalLoaderContext)

  useEffect(() => {
    getDevice(apiEndpoints.systemadmindeviceregistry.getdevicebyid.replace("{id}", match.params.id))
    getCompany(apiEndpoints.systemadmindeviceregistry.listcompanies)
    getExternalDevice(apiEndpoints.systemadmindeviceregistry.listexternaldeviceregistrydevicetypes)
  }, [getDevice, match.params.id, getCompany, getExternalDevice])

  const handleSubmit = (objectToSave) => {
    editDevice(apiEndpoints.systemadmindeviceregistry.updatedevice, objectToSave)
  }

  useEffect(() => {
    loadingContext.setLoading(() => companyResult.status === 1)
  })
  useEffect(() => {
    loadingContext.setLoading(() => externalDeviceResult.status === 1)
  })

  const feedback = {
    errorTitle: t("sysadmin.device_could_not_be_updated", "Device could not be updated")
  }

  return (
    <div>
      <PageTabs
        routeBack
        tabs={[
          {
            path: allRoutes.SystemadminDevicesRegister(),
            title: t("global.back", "Back")
          }
        ]}
      />
      <Container>
        <Box marginY={3}>
          <Grid container direction="row" justifyContent="flex-start" alignItems="center">
            <Typography variant="h2">{t("sysadmin.edit_device", "Edit device")}</Typography>
          </Grid>
        </Box>

        {companyResult.status === 2 && externalDeviceResult.status === 2 && deviceResult.status === 2 && (
          <DeviceForm
            companyResult={companyResult}
            equipmentTypesResult={externalDeviceResult}
            onSubmit={handleSubmit}
            feedback={feedback}
            editDevice={deviceResult.data}
            result={editDeviceResult}
          />
        )}
      </Container>
    </div>
  )
}

export default DeviceRegisterEdit
